import * as React from 'react'

const SvgProgressIcon = ({ stroke }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 11.2001V15.2001M14 9.20007V15.2001M10 5.20007V15.2001M5.8 19.2001H14.2C15.8802 19.2001 16.7202 19.2001 17.362 18.8731C17.9265 18.5855 18.3854 18.1265 18.673 17.562C19 16.9203 19 16.0802 19 14.4001V6.00007C19 4.31992 19 3.47984 18.673 2.8381C18.3854 2.27362 17.9265 1.81467 17.362 1.52705C16.7202 1.20007 15.8802 1.20007 14.2 1.20007H5.8C4.11984 1.20007 3.27976 1.20007 2.63803 1.52705C2.07354 1.81467 1.6146 2.27362 1.32698 2.8381C1 3.47984 1 4.31992 1 6.00007V14.4001C1 16.0802 1 16.9203 1.32698 17.562C1.6146 18.1265 2.07354 18.5855 2.63803 18.8731C3.27976 19.2001 4.11984 19.2001 5.8 19.2001Z"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgProgressIcon
